import { CheckIcon } from "@chakra-ui/icons";
import { FormControl, FormLabel, InputGroup, InputRightElement, Text } from "@chakra-ui/react";
import { DatePicker, DatePickerProps } from "./DatePicker";

interface DatePickerFormControlProps extends DatePickerProps {
  label: string;
}
const DatePickerFormControl = ({ label, date, ...datePickerProps }: DatePickerFormControlProps) => {
  return (
    <FormControl w="100%">
      <FormLabel>
        <Text fontSize="sm">{label}</Text>
      </FormLabel>
      <InputGroup w="100%">
        <DatePicker
          w="100%"
          date={date}
          buttonProps={{
            w: "100%",
          }}
          {...datePickerProps}
        />

        {date && (
          <InputRightElement>
            <CheckIcon color="green.500" />
          </InputRightElement>
        )}
      </InputGroup>
    </FormControl>
  );
};

export default DatePickerFormControl;
